import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import AccountLayout from 'components/layout/account';
import { BackArrowHistory } from 'components/navigation/back-arrow';
import UserInfoForm from 'components/user-info-form';
import useAuth from 'hooks/auth/use-auth';
import useAuthRedirects from 'hooks/auth/use-auth-redirects';
import useEffectOnce from 'hooks/use-effect-once';
import { useOtpFeature } from 'hooks/use-otp-feature';
import AuthRequired from 'pages/authentication/auth-required';
import { routes } from 'utils/routing';

import { BordersAndBackground, StyledLink, VerifyNowText } from './styled/verify-phone-number';

const AccountInfo: FC = () => {
  const { formatMessage } = useIntl();
  const { user, updateUserInfo, refreshCurrentUser } = useAuth();
  const { smsOtpEnabled } = useOtpFeature();

  useAuthRedirects();

  useEffectOnce(() => {
    refreshCurrentUser();
  });

  return (
    <div>
      <Helmet title={formatMessage({ id: 'accountDetails' })} />
      <AuthRequired>
        <BackArrowHistory />
        <AccountLayout header={formatMessage({ id: 'account' })}>
          {smsOtpEnabled && (
            <BordersAndBackground>
              <VerifyNowText>{formatMessage({ id: 'pleaseVerifyYourPhoneNumber' })}</VerifyNowText>
              {/* TODO: update route when verify phone number route is created */}
              <StyledLink to={routes.info}>{formatMessage({ id: 'verifyNow' })}</StyledLink>
            </BordersAndBackground>
          )}
          <UserInfoForm user={user} onSubmit={updateUserInfo} />
        </AccountLayout>
      </AuthRequired>
    </div>
  );
};

export default AccountInfo;
